import { Dispatch, Store } from "redux";
import { TActionRequest } from "../../base/types/redux";
import MiddlewareRegistry from "../../base/redux/MiddlewareRegistry";
import { apiGetEkycOptions, apiCreateEkyc, apiGetStockCodeOptions } from "./services";
import { ACTION_TYPES } from "./actionTypes";
import { setEkycOptions, setCreateEkycState, setStockCodeOptions } from "./actions";
import { message } from 'antd';

export const middleware =
  ({ dispatch, getState }: Store) =>
  (next: Function) =>
  async (action: TActionRequest<any>) => {
    next(action);
    switch (action.type) {
      case ACTION_TYPES.GET_EKYC_OPTIONS: {
        return await handleGetEkycOptions(dispatch, action, getState);
      }
      case ACTION_TYPES.POST_CREATE_EKYC: {
        return await handleCreteEkyc(dispatch, action, getState);
      }
      case ACTION_TYPES.GET_STOCK_CODE_OPTIONS: {
        return await handleGetStockCodeOptions(dispatch, action, getState);
      }
    }
  };

MiddlewareRegistry.register(middleware);

const handleGetEkycOptions = async (
  dispatch: Dispatch,
  action: TActionRequest<any>,
  getState: () => {  }
) => {
  try {
    const response = await apiGetEkycOptions(action.params);
    if (response) {
      dispatch(setEkycOptions(response));
    }
  } catch (err:any) {
    message.error(err.response?.data.status.message);
  }
};

const handleCreteEkyc = async (
  dispatch: Dispatch,
  action: TActionRequest<any>,
  getState: () => {  }
) => {
  try {
    action.params.invest_portfolio_ids = action.params.invest_portfolio_ids.toString();
    const response = await apiCreateEkyc(action.params);
    if (response?.status.code === "A200") {
      dispatch(setCreateEkycState({ isFetching: false, isSuccess: true, data: response.data }));
    } else {
      dispatch(setCreateEkycState({ isFetching: false, isSuccess: false, data: response.data }));
    }
  } catch (err: any) {
    message.error(err.response?.data.status.message);
    dispatch(setCreateEkycState({ isFetching: false, isSuccess: false, data: err }));
  }
}

const handleGetStockCodeOptions = async (
  dispatch: Dispatch,
  action: TActionRequest<any>,
  getState: () => {  }
) => {
  try {
    const response = await apiGetStockCodeOptions(action.params);
    if (response) {
      dispatch(setStockCodeOptions(response));
    }
  } catch (err:any) {
    message.error(err.response?.data.status.message);
  }
};